import React, { useEffect, useState } from 'react';
import './Child.css';
import Banner from '../Banner/Banner';
import child1 from '../../../../image/avatar/child1.png';
import {Image, Modal} from 'antd';
import CompanyFooter from '../../../footer/CompanyFooter';
import ReactPlayer from 'react-player';
import { useDispatchRoot, useSelectorRoot } from '../../../../store/store';
import { getChild } from '../../../../store/controls/Child.slice';
import { useLocation } from 'react-router-dom';
import SYSTEM_CONSTANTS from '../../../../common/constants';

function Child() {
  const dispath = useDispatchRoot();
  const location = useLocation();
  const {Child} = useSelectorRoot(state => state.Child);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState('');
  useEffect(() => {
    const id = location.pathname.split('/').pop();
    console.log(id);
    dispath(getChild(Number(id)));
  },[]);
  const showModal = (videoUrl: string) => {
    setCurrentVideoUrl(videoUrl);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setCurrentVideoUrl('');
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setCurrentVideoUrl('');
  };
  // const userData = {
  //   fullName: "Nguyễn Gia Huy",
  //   birthDate: "01/01/2000",
  //   hometown: "Bắc Ninh, Việt Nam",
  //   status: "Lorem ipsum dolor sit amet consectetur. Pellentesque nec placerat neque et elit.",
  //   image: child1,
  //   images: [
  //     { title: "Tiêu đề 1", date: "01/01/2024", link: child1 },
  //     { title: "Tiêu đề 2", date: "01/01/2024", },
  //     { title: "Tiêu đề 3", date: "01/01/2024" },
  //     { title: "Tiêu đề 4", date: "01/01/2024" },
  //     { title: "Tiêu đề 5", date: "01/01/2024" },
  //     { title: "Tiêu đề 6", date: "01/01/2024" },
  //     { title: "Tiêu đề 7", date: "01/01/2024" },
  //     { title: "Tiêu đề 8", date: "01/01/2024" },
  //   ],
  //   video: [
  //       { title: "Tiêu đề 1", date: "01/01/2024", link: "https://www.youtube.com/watch?v=su3x3oabOsQ" },
  //       { title: "Tiêu đề 2", date: "01/01/2024" },
  //       { title: "Tiêu đề 3", date: "01/01/2024" },
  //       { title: "Tiêu đề 4", date: "01/01/2024" },
  //       { title: "Tiêu đề 5", date: "01/01/2024" },
  //       { title: "Tiêu đề 6", date: "01/01/2024" },
  //       { title: "Tiêu đề 7", date: "01/01/2024" },
  //       { title: "Tiêu đề 8", date: "01/01/2024" },
  //       { title: "Tiêu đề 9", date: "01/01/2024" },
  //   ]
  // };
  const [userData, setUserData] = useState(Child);
  useEffect(() => {
    setUserData(Child);
    console.log(Child);
  }, [Child]);
  return (
    <div>
      <Banner title={"CHÂN DUNG"}></Banner>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',width: '100%', height: 75 }}>
        <img src={SYSTEM_CONSTANTS.HOST + userData?.Avatar?.data.attributes.url} alt="Profile" className="profile-pic" style={{position: 'relative', top: -75, left: 0, width: 150, height: 150, borderRadius: 150}} />
      </div>
      <div className="profile-info">
        
        <div className="basic-info">
          <h3>Thông tin cơ bản</h3>
          <p>Họ và tên: {userData?.Name}</p>
          <p>Ngày sinh: {userData?.Birthday}</p>
          <p>Quê quán: {userData?.Address}</p>
          <p>Tình trạng sức khoẻ: {userData?.Status}</p>
        </div>
      </div>
      <div className="media-section">
        <h3>Hình ảnh</h3>
        <div className="media-grid">
          {userData?.Images?.data?.map((item, index) => (
            <div className="media-item" key={index}>
                <Image
                    width={200}
                    height={200}
                    src={SYSTEM_CONSTANTS.HOST + item.attributes.url}
                    preview={item.attributes.url ? { src: SYSTEM_CONSTANTS.HOST + item.attributes.url } : false}
                    fallback="data:image/png;base64,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"
                />
              <div className="media-title">{item.attributes.name}</div>
              <div className="media-date">{item.attributes.createdAt}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="media-section">
        <h3>Video</h3>
        <div className="media-grid">
          {userData?.videos.data.map((item, index) => (
            <div className="media-item" key={index} onClick={() => item.attributes?.Video?.data.attributes.url && showModal(SYSTEM_CONSTANTS.HOST + item.attributes?.Video?.data.attributes.url)}>
                <div className="player-wrapper">
                 <div className="player-overlay" />
                <ReactPlayer url={SYSTEM_CONSTANTS.HOST + item.attributes?.Video?.data.attributes.url} playing={false} controls={false} pip={false} light={true} style={{width: '400px', height: '200px'}} width="100%"
        height="100%"></ReactPlayer>
                </div>
              <div className="media-title">{item.attributes?.Title}</div>
              <div className="media-date">{item.attributes?.publishedAt}</div>
            </div>
          ))}
        </div>
      </div>
      <CompanyFooter />
      <Modal
        title="Video"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <ReactPlayer
          url={currentVideoUrl}
          controls
          width="100%"
          height="300px"
        />
      </Modal>
    </div>
  );
}

export default Child;